<script context="module">
const TEXTS_IN_VARIOUS_LANGUAGE = {
	'default': {
		'page_title': 'You can [***] on this site.',
		'page_title_hash': '21d4cb15b281c1ee6e123e36e0436952',
		'page_title_resolve_utl': '/resolve/You%20can%20%5B***%5D%20on%20this%20site.%0A%2321d4cb15b281c1ee6e123e36e0436952%0A%23D8S5/',
		'page_title_answer_url': '/answer/21d4cb15b281c1ee6e123e36e0436952/You%20can%20%5Bdeclare%20in%20secret%5D%20on%20this%20site./secret',
		'default_message' : 'For example, you can enter "some text [HERE IS THE SECRET] some text" to declare it as secret.',
		'step1': 'STEP 1: Enter the message you wish to declare.',
		'step2': 'STEP 2: Enter your secret password.',
		'step3': 'STEP 3: Share your results!',
		'become_secret': 'A message that became secret.',
		'become_secret_example': 'Example of confidential message.',
		'hash_tag': '#D8S5',
		'confirmation_step0': 'Confirm this message.',
		'confirmation_step1': 'Enter appropriate text in \'[***]\'.',
		'instructions_1': 'This is the secret text that you declare. Do not change this part.',
		'instructions_2': 'This string is used to certify the declaration. Do not change this line.',
		'instructions_3': 'You can write anything you want from here down. You don\'t have to write anything.',
		'copied': 'Copied!',
	},
	'ja': {
		'page_title': 'このサイトでは[***]ができます。',
		'page_title_hash': '36816c044fdf6c074a21fd92f9b24524',
		'page_title_resolve_utl': '/resolve/%E3%81%93%E3%81%AE%E3%82%B5%E3%82%A4%E3%83%88%E3%81%A7%E3%81%AF%5B***%5D%E3%81%8C%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%99%E3%80%82%0A%2336816c044fdf6c074a21fd92f9b24524%0A%23%E7%A7%98%E5%AF%86%E5%AE%A3%E8%A8%80/',
		'page_title_answer_url': '/answer/36816c044fdf6c074a21fd92f9b24524/%E3%81%93%E3%81%AE%E3%82%B5%E3%82%A4%E3%83%88%E3%81%A7%E3%81%AF%5B%E7%A7%98%E5%AF%86%E3%81%AE%E3%83%A1%E3%83%83%E3%82%BB%E3%83%BC%E3%82%B8%E4%BD%9C%E6%88%90%5D%E3%81%8C%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%99%E3%80%82/secret',
		'default_message' : '例えば、「メッセージ[ここは秘密です]メッセージ。」と入力すると秘密の文章ができます。',
		'step1': 'STEP1 秘密にしたいメッセージを入力してください',
		'step2': 'STEP2 合言葉を入力してください',
		'step3': 'STEP3 結果をシェアしてください',
		'become_secret': '秘密になったメッセージ',
		'become_secret_example': '秘密になったメッセージ例',
		'hash_tag': '#秘密宣言',
		'confirmation_step0': 'このメッセージを確認します',
		'confirmation_step1': '[***] に入るテキストを入力してください',
		'instructions_1': '秘密になった文章です。コピペする際はこの部分を変更しないでください。',
		'instructions_2': '秘密の内容を証明するための文字列です。この行も変更しないでください。',
		'instructions_3': 'ここから下は何を書いても大丈夫です。なくても大丈夫です。',
		'copied': 'コピーしました。',
	},
}

let texts;
if (window.navigator.language in TEXTS_IN_VARIOUS_LANGUAGE) {
	texts = TEXTS_IN_VARIOUS_LANGUAGE[window.navigator.language];
} else {
	texts = TEXTS_IN_VARIOUS_LANGUAGE['default'];
}

export const  _ = (key, default_message) => {
	if (key in texts) {
		return texts[key];
	} else {
		return default_message;
	}
}

export const isLanguage = (language) => {
	return window.navigator.language === language;
}
</script>